import React from 'react';
import { isAllowEdit } from 'features/supplier/utils';

import ModalContainer from '@components/modals/ModalContainer';
import CommonImage from '@components/CommonImage';

import { changeDateFormat, getFileType, getIconByFileType } from '@utils/Util';

const ViewDocuments = ({ onClose, title, onRemoveClick, documentList }) => {
	const renderDocuments = (type) => {
		let fileType;
		if (type.docUrl) {
			fileType = getFileType(type.docUrl);
		} else {
			fileType = getFileType(type.name);
		}
		if (fileType === 'IMAGE' || fileType === 'NO_FILE')
			return <img width="54px" src={type.docUrl} alt="Upload" />;
		else
			return (
				<img
					width="54px"
					src={getIconByFileType(fileType)}
					onClick={() => {
						if (type.docUrl) {
							window.open(type.docUrl, '_blank').focus();
						}
					}}
					alt="certificate-image"
				/>
			);
	};

	return (
		<ModalContainer className="osc-certificate-modal">
			<div className="common-popup osc-certificate-modal">
				<div className="common-popup-header d-flex justify-content-between">
					<div className="popup-tilte">
						<h3 className="semibold-16 mb-0">{title}</h3>
					</div>
					<div className="close-btn" onClick={onClose}>
						<CommonImage src="/icons/close.svg" alt="close" />
					</div>
				</div>
				<div className="common-popup-body scroll-y-label">
					<div className="ocs-pdfs">
						{documentList?.map((item) => (
							<div
								className="ocs-pdf-single d-flex align-items-start"
								key={item?.documentResponse?.id || item?.id}
							>
								<div className="img">{renderDocuments(item?.documentResponse || item)}</div>
								{item?.rank && (
									<p className="regular-12 gray_dark_01">
										Rank:
										{item.rank}
									</p>
								)}
								{item?.auditDate && (
									<p className="regular-12 gray_dark_02">
										Audited on&nbsp;
										{changeDateFormat(item.auditDate, '', 'DD MMM, YYYY')}
									</p>
								)}
								{item?.expiryDate && (
									<p className="regular-12 gray_dark_02">
										Expiry Date: {changeDateFormat(item?.expiryDate, '', 'DD MMM, YYYY')}
									</p>
								)}
								{isAllowEdit() && (
									<div
										className="action-icon"
										onClick={() => onRemoveClick(item?.documentResponse?.id || item?.id)}
									>
										<CommonImage src="/icons/delete_gray.svg" alt="check" />
									</div>
								)}
							</div>
						))}
					</div>
				</div>
			</div>
		</ModalContainer>
	);
};

export default ViewDocuments;
